<div class="contenedor-filtros p-16">
    <h2 class="m-0">Filtros</h2>
    <mat-divider></mat-divider>
    <br />
    <div
        fxLayoutGap="30px"
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign="space-between center"
    >
        <mat-form-field
            class="full-width"
            *ngIf="_menuUsuarioSrvc.esSupervisor()"
        >
            <mat-label>Clientes</mat-label>
            <mat-chip-list
                #clientesList
                aria-label="Clientes"
                [multiple]="false"
            >
                <mat-chip
                    class="primary"
                    *ngFor="let clienteSeleccionado of filtros.idCliente"
                    [removable]="true"
                    (removed)="quitarFiltro('idCliente')"
                >
                    <span>{{ clienteSeleccionado.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.idCliente[0].descripcion === 'Todos'"
                    #clienteInput
                    [formControl]="clienteCtrl"
                    [matAutocomplete]="autCompleteCliente"
                    [matChipInputFor]="clientesList"
                />
            </mat-chip-list>
            <mat-autocomplete
                #autCompleteCliente="matAutocomplete"
                (optionSelected)="
                    seleccionarFiltro(
                        $event,
                        'id',
                        'nombre',
                        clienteCtrl,
                        'clienteInput',
                        'idCliente'
                    )
                "
            >
                <mat-option
                    *ngFor="let clienteFiltrado of filteredClientes | async"
                    [value]="clienteFiltrado"
                >
                    {{ clienteFiltrado.nombre }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Vigencia</mat-label>
            <mat-chip-list
                #vigenciaList
                aria-label="Vigencia"
                [multiple]="false"
            >
                <mat-chip
                    class="primary"
                    *ngFor="let vigenciaSeleccionada of filtros.vigencia"
                    [removable]="true"
                    (removed)="quitarFiltro('vigencia')"
                >
                    <span>{{ vigenciaSeleccionada.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.vigencia[0].descripcion === 'Todos'"
                    #vigenciaInput
                    [formControl]="vigenciaCtrl"
                    [matAutocomplete]="autocompleteVigencia"
                    [matChipInputFor]="vigenciaList"
                />
            </mat-chip-list>
            <mat-autocomplete
                #autocompleteVigencia="matAutocomplete"
                (optionSelected)="
                    seleccionarFiltro(
                        $event,
                        'id',
                        'descripcion',
                        vigenciaCtrl,
                        'vigenciaInput',
                        'vigencia'
                    )
                "
            >
                <mat-option
                    *ngFor="let vigenciaFiltrada of filteredVigencia | async"
                    [value]="vigenciaFiltrada"
                >
                    {{ vigenciaFiltrada.descripcion }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Situación</mat-label>
            <mat-chip-list
                #situacionList
                aria-label="Situacion"
                [multiple]="false"
            >
                <mat-chip
                    class="primary"
                    *ngFor="let situacionSeleccionada of filtros.situacion"
                    [removable]="true"
                    (removed)="quitarFiltro('situacion')"
                >
                    <span>{{ situacionSeleccionada.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.situacion[0].descripcion === 'Todos'"
                    #situacionInput
                    [formControl]="situacionCtrl"
                    [matAutocomplete]="autoCompleteSituacion"
                    [matChipInputFor]="situacionList"
                />
            </mat-chip-list>
            <mat-autocomplete
                #autoCompleteSituacion="matAutocomplete"
                (optionSelected)="
                    seleccionarFiltro(
                        $event,
                        'id',
                        'descripcion',
                        situacionCtrl,
                        'situacionInput',
                        'situacion'
                    )
                "
            >
                <mat-option
                    *ngFor="let situacionFiltrado of filteredSituacion | async"
                    [value]="situacionFiltrado"
                >
                    {{ situacionFiltrado.descripcion }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
    <div fxLayoutGap="10px" fxLayout="row" fxLayoutAlign="start start">
        <button
            mat-raised-button
            color="primary"
            (click)="limpiarTodosFiltros()"
        >
            <mat-icon>clear</mat-icon>
            Limpiar filtros
        </button>
        <button mat-raised-button color="accent" (click)="filtrar()">
            <mat-icon>tune</mat-icon> Filtrar
        </button>
    </div>
</div>
